import { createInertiaApp, router } from '@inertiajs/react'
import { createRoot } from 'react-dom/client'
import '../styles/application.css'

const pages = import.meta.glob('../pages/**/*.tsx', { eager: true })

const getCsrfToken = () => {
  return document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || ''
}

const setCsrfMeta = (token?: string | null) => {
  if (!token) return
  const el = document.querySelector('meta[name="csrf-token"]')
  if (el) el.setAttribute('content', token)
}

router.on('before', (event) => {
  const csrfToken = getCsrfToken()
  if (csrfToken) {
    event.detail.visit.headers['X-CSRF-Token'] = csrfToken
  }
})

// Keep the <meta name="csrf-token"> tag in sync with the freshly-issued token
// the server shares on every Inertia response. Without this, the meta tag keeps
// the token from the original full page load and goes stale after client-side
// navigation, causing bare fetch() requests to be rejected with 422 CSRF errors.
router.on('success', (event) => {
  const props = event.detail.page.props as { csrf_token?: string }
  setCsrfMeta(props.csrf_token)
})

createInertiaApp({
  resolve: (name) => {
    const page = pages[`../pages/${name}.tsx`]
    if (!page) {
      throw new Error(`Page not found: ${name}`)
    }
    return page
  },
  setup({ el, App, props }) {
    createRoot(el).render(<App {...props} />)
  },
})
